import { readonly, ref } from "vue";

/**
 * Whether the server refused the Designer or the Operator for want of a license.
 *
 * Set by the infra that sees the refusal — a `403 license_required` from any API call (`@/api`), or
 * a room join acked `{ ok: false, code: "license_required" }` (`@/socket`) — and read by both
 * layouts, which then show `NoLicenseState` instead of the page. In `shared/` because both
 * sections read it, and free of imports so the infra can set it without a cycle.
 *
 * It is cleared when a layout mounts (entering the Designer or the Operator asks again) and by
 * "Try again".
 */
const required = ref(false);

/** The server answered `license_required`. */
export function markLicenseRequired(): void {
	required.value = true;
}

/** Forget it, so the next request decides again. */
export function clearLicenseRequired(): void {
	required.value = false;
}

export function useLicenseGate() {
	return { required: readonly(required), clear: clearLicenseRequired };
}
